// import { useEffect, useMemo, useState } from "react";
// import { collection, getDocs, query, where } from "firebase/firestore";
// import { db } from "../../firebase";
// import css from "./BusinessPartnerOrders.module.css";

// function parseChoice(rawChoice) {
//   try {
//     if (Array.isArray(rawChoice)) return rawChoice;
//     if (typeof rawChoice === "string") return JSON.parse(rawChoice || "[]");
//   } catch (e) {
//     console.error("parseChoice error:", e);
//   }
//   return [];
// }

// function toTimestamp(t) {
//   if (!t) return 0;
//   if (typeof t === "number") return Number.isFinite(t) ? t : 0;
//   if (typeof t === "string") {
//     const p = Date.parse(t);
//     return Number.isFinite(p) ? p : 0;
//   }
//   if (t?.seconds) {
//     return t.seconds * 1000 + Math.round((t.nanoseconds || 0) / 1e6);
//   }
//   return 0;
// }

// function getOrderTs(order = {}) {
//   const candidates = [
//     order?.createdAtClient,
//     order?.createdAtISO,
//     order?.createdAt,
//     order?.date,
//     order?.created_at,
//     order?.created,
//   ];

//   for (const t of candidates) {
//     const ts = toTimestamp(t);
//     if (ts > 0) return ts;
//   }

//   return 0;
// }

// function fmtDate(ms) {
//   if (!ms) return "—";
//   return new Date(ms).toLocaleString("uk-UA", {
//     year: "numeric",
//     month: "2-digit",
//     day: "2-digit",
//     hour: "2-digit",
//     minute: "2-digit",
//   });
// }

// function safeMoney(v) {
//   const n = Number(v || 0);
//   if (!Number.isFinite(n)) return "—";
//   return new Intl.NumberFormat("uk-UA", {
//     style: "currency",
//     currency: "UAH",
//     maximumFractionDigits: 0,
//   }).format(n);
// }

// function shortId(id = "") {
//   const s = String(id || "");
//   return s.slice(-6) || "—";
// }

// function getStatus(order = {}) {
//   return order?.statusFlow?.current || order?.status || "Очікує підтвердження";
// }

// function getPaymentMethodRaw(order = {}) {
//   const raw =
//     order?.payment?.method || order?.paymentMethod || order?.pay || "";

//   const v = String(raw).toLowerCase().trim();

//   if (v.includes("invoice") || v.includes("рах")) return "invoice";
//   if (v.includes("card") || v.includes("карт")) return "card";

//   return v || "";
// }

// function getPaymentMethodLabel(order = {}) {
//   const m = getPaymentMethodRaw(order);
//   if (m === "invoice") return "По рахунку";
//   if (m === "card") return "Картою";
//   return m || "—";
// }

// function getPaymentStatusRaw(order = {}) {
//   return (
//     order?.payment?.status || order?.paymentStatus || order?.liqpayStatus || ""
//   );
// }

// function isPaidOrder(order = {}) {
//   if (order?.isPaid === true) return true;

//   const raw = String(getPaymentStatusRaw(order)).toLowerCase().trim();
//   return ["paid", "success", "sandbox", "true", "1"].includes(raw);
// }

// function getPaymentStatusLabel(order = {}) {
//   if (isPaidOrder(order)) return "оплачено";

//   const raw = String(getPaymentStatusRaw(order)).toLowerCase().trim();

//   if (!raw) return "не оплачено";
//   if (raw === "pending") return "очікує оплату";
//   if (raw === "invoice_pending") return "очікує рахунок";
//   if (raw === "invoice_created") return "рахунок сформовано";
//   if (raw === "partially_paid") return "частково оплачено";
//   if (raw === "failure" || raw === "error") return "помилка";

//   return raw;
// }

// function getInvoiceInfo(order = {}) {
//   const invoiceUrl =
//     order?.invoiceUrl ||
//     order?.invoiceMeta?.invoiceUrl ||
//     order?.invoice?.invoiceUrl ||
//     "";

//   const invoiceNumber =
//     order?.invoiceNumber ||
//     order?.invoiceMeta?.invoiceNumber ||
//     order?.invoice?.invoiceNumber ||
//     "";

//   const invoiceDate =
//     order?.invoiceDate ||
//     order?.invoiceMeta?.invoiceDate ||
//     order?.invoice?.invoiceDate ||
//     "";

//   return {
//     invoiceUrl: String(invoiceUrl || ""),
//     invoiceNumber: String(invoiceNumber || ""),
//     invoiceDate: String(invoiceDate || ""),
//   };
// }

// function getOrderTotal(order = {}) {
//   const candidates = [
//     order?.pricing?.finishPrice,
//     order?.finishPrice,
//     order?.pricing?.totalPrice,
//     order?.totalPrice,
//   ];

//   for (const v of candidates) {
//     const n = Number(v);
//     if (Number.isFinite(n)) return n;
//   }

//   return 0;
// }

// function getBuyerFullName(order = {}) {
//   return (
//     order?.buyer?.fullName ||
//     order?.userSnapshot?.displayName ||
//     [order?.name, order?.surName].filter(Boolean).join(" ") ||
//     "—"
//   );
// }

// function getDeliveryLine(order = {}) {
//   const city = order?.delivery?.cityName || order?.cityName || "";
//   const warehouse =
//     order?.delivery?.warehouse || order?.selectedDepartment || "";
//   const area = order?.delivery?.cityArea || "";

//   const parts = [city, area, warehouse].filter(Boolean);
//   return parts.length ? parts.join(", ") : "—";
// }

// function getItemFinalUnitPrice(el) {
//   const qty = Math.max(1, Number(el?.quantity ?? el?.qty ?? 1) || 1);

//   const purchasedUnitPrice = Number(el?.purchasedUnitPrice);
//   if (Number.isFinite(purchasedUnitPrice) && purchasedUnitPrice > 0) {
//     return purchasedUnitPrice;
//   }

//   const finalPrice = Number(el?.finalPrice);
//   if (Number.isFinite(finalPrice) && finalPrice > 0) {
//     return finalPrice;
//   }

//   const unitPrice = Number(el?.unitPrice);
//   if (Number.isFinite(unitPrice) && unitPrice > 0) {
//     return unitPrice;
//   }

//   const lineTotal = Number(el?.lineTotal);
//   if (Number.isFinite(lineTotal) && lineTotal > 0) {
//     return Number((lineTotal / qty).toFixed(2));
//   }

//   const price = Number(el?.price);
//   if (Number.isFinite(price) && price > 0) {
//     return price;
//   }

//   return 0;
// }

// function isBusinessPartnerOrder(order = {}) {
//   const c = String(
//     order?.userCategory || order?.userSnapshot?.category || "",
//   ).toLowerCase();

//   return c.includes("бізнес") && c.includes("партнер");
// }

// export default function BusinessPartnerOrders({ user }) {
//   const [orders, setOrders] = useState([]);
//   const [openMap, setOpenMap] = useState({});
//   const [loading, setLoading] = useState(true);

//   const toggleOpen = (id) => {
//     setOpenMap((prev) => ({ ...prev, [id]: !prev[id] }));
//   };

//   useEffect(() => {
//     const loadOrders = async () => {
//       if (!user?.uid) {
//         setOrders([]);
//         setLoading(false);
//         return;
//       }

//       try {
//         setLoading(true);

//         const ordersRef = collection(db, "orders");

//         const [snapByUser, snapByUserId] = await Promise.all([
//           getDocs(query(ordersRef, where("user", "==", user.uid))),
//           getDocs(query(ordersRef, where("userId", "==", user.uid))),
//         ]);

//         const map = new Map();

//         snapByUser.forEach((d) => {
//           map.set(d.id, { id: d.id, ...d.data() });
//         });

//         snapByUserId.forEach((d) => {
//           map.set(d.id, { id: d.id, ...d.data() });
//         });

//         const list = Array.from(map.values())
//           .filter((order) => isBusinessPartnerOrder(order))
//           .map((order) => ({
//             ...order,
//             _choice: parseChoice(order?.choice),
//           }))
//           .sort((a, b) => getOrderTs(b) - getOrderTs(a));

//         setOrders(list);
//       } catch (e) {
//         console.error("Помилка завантаження бізнес-замовлень:", e);
//         setOrders([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     loadOrders();
//   }, [user?.uid]);

//   const hasOrders = useMemo(() => orders.length > 0, [orders]);

//   if (!user?.uid) return null;

//   return (
//     <div className={css.wrap}>
//       <div className={css.head}>
//         <h3 className={css.title}>Мої замовлення</h3>
//       </div>

//       {loading && <div className={css.empty}>Завантаження...</div>}

//       {!loading && !hasOrders && (
//         <div className={css.empty}>У вас ще немає бізнес-замовлень.</div>
//       )}

//       {!loading &&
//         orders.map((order) => {
//           const invoice = getInvoiceInfo(order);
//           const isOpen = !!openMap[order.id];
//           const isPaid = isPaidOrder(order);
//           const dueAmount = Number(order?.dueAmount || 0);
//           const showPaymentLink =
//             !!order?.paymentLink && !isPaid && dueAmount > 0;

//           return (
//             <div key={order.id} className={css.card}>
//               <div className={css.rowTop}>
//                 <div>
//                   <div className={css.label}>Дата</div>
//                   <div>{fmtDate(getOrderTs(order))}</div>
//                 </div>

//                 <div>
//                   <div className={css.label}>ID</div>
//                   <div>№{shortId(order.id || order.orderId || order.uid)}</div>
//                 </div>

//                 <div>
//                   <div className={css.label}>Покупець</div>
//                   <div>{getBuyerFullName(order)}</div>
//                 </div>

//                 <div>
//                   <div className={css.label}>Статус</div>
//                   <div>{getStatus(order)}</div>
//                 </div>

//                 <div>
//                   <div className={css.label}>Оплата</div>
//                   <div>{getPaymentMethodLabel(order)}</div>
//                 </div>

//                 <div>
//                   <div className={css.label}>Оплачено</div>
//                   <div>{isPaid ? "Так" : "Ні"}</div>
//                 </div>

//                 <div>
//                   <div className={css.label}>Сума</div>
//                   <div>{safeMoney(getOrderTotal(order))}</div>
//                 </div>

//                 <button
//                   type="button"
//                   className={css.moreBtn}
//                   onClick={() => toggleOpen(order.id)}
//                 >
//                   {isOpen ? "Сховати" : "Детальніше"}
//                 </button>
//               </div>

//               {isOpen && (
//                 <div className={css.details}>
//                   <div className={css.col}>
//                     <h4 className={css.subTitle}>Дані замовлення</h4>

//                     <p>
//                       <b>Спосіб оплати:</b> {getPaymentMethodLabel(order)}
//                     </p>

//                     <p>
//                       <b>Статус оплати:</b> {getPaymentStatusLabel(order)}
//                     </p>

//                     <p>
//                       <b>Адреса доставки:</b> {getDeliveryLine(order)}
//                     </p>

//                     <p>
//                       <b>Загальна сума:</b> {safeMoney(getOrderTotal(order))}
//                     </p>

//                     {Number(order?.paidAmount || 0) > 0 && (
//                       <p>
//                         <b>Оплачено:</b> {safeMoney(order.paidAmount)}
//                       </p>
//                     )}

//                     {Number(order?.dueAmount || 0) > 0 && (
//                       <p>
//                         <b>До сплати:</b> {safeMoney(order.dueAmount)}
//                       </p>
//                     )}

//                     {invoice?.invoiceUrl && (
//                       <p>
//                         <b>Рахунок:</b>{" "}
//                         <a
//                           href={invoice.invoiceUrl}
//                           target="_blank"
//                           rel="noreferrer"
//                         >
//                           {invoice.invoiceNumber || "Відкрити рахунок"}
//                         </a>
//                         {invoice?.invoiceDate
//                           ? ` (${invoice.invoiceDate})`
//                           : ""}
//                       </p>
//                     )}

//                     {!invoice?.invoiceUrl &&
//                       getPaymentMethodRaw(order) === "invoice" && (
//                         <p>
//                           <b>Рахунок:</b> ще не сформовано
//                         </p>
//                       )}

//                     {showPaymentLink && (
//                       <div className={css.payBox}>
//                         <b>Посилання для оплати:</b>
//                         <a
//                           href={order.paymentLink}
//                           target="_blank"
//                           rel="noreferrer"
//                           className={css.payLink}
//                         >
//                           Відкрити оплату
//                         </a>
//                       </div>
//                     )}
//                   </div>

//                   <div className={css.col}>
//                     <h4 className={css.subTitle}>
//                       Позиції ({order._choice.length})
//                     </h4>

//                     {order._choice.length === 0 && (
//                       <div className={css.emptySmall}>Позицій немає</div>
//                     )}

//                     {order._choice.map((item, index) => {
//                       const qty = Number(item?.quantity ?? item?.qty ?? 1) || 1;
//                       const price = getItemFinalUnitPrice(item);

//                       return (
//                         <div key={index} className={css.item}>
//                           <div className={css.itemName}>
//                             {item?.bookName ||
//                               item?.name ||
//                               `Товар ${index + 1}`}
//                           </div>
//                           <div className={css.itemMeta}>x{qty}</div>
//                           <div className={css.itemPrice}>
//                             {safeMoney(price)}
//                           </div>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </div>
//               )}
//             </div>
//           );
//         })}
//     </div>
//   );
// }
import { useEffect, useMemo, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import css from "./BusinessPartnerOrders.module.css";

function parseChoice(rawChoice) {
  try {
    if (Array.isArray(rawChoice)) return rawChoice;
    if (typeof rawChoice === "string") return JSON.parse(rawChoice || "[]");
  } catch (e) {
    console.error("parseChoice error:", e);
  }
  return [];
}

function toTimestamp(t) {
  if (!t) return 0;
  if (typeof t === "number") return Number.isFinite(t) ? t : 0;
  if (typeof t === "string") {
    const p = Date.parse(t);
    return Number.isFinite(p) ? p : 0;
  }
  if (t?.seconds) {
    return t.seconds * 1000 + Math.round((t.nanoseconds || 0) / 1e6);
  }
  return 0;
}

function getOrderTs(order = {}) {
  const candidates = [
    order?.createdAtClient,
    order?.createdAtISO,
    order?.createdAt,
    order?.date,
    order?.created_at,
    order?.created,
  ];

  for (const t of candidates) {
    const ts = toTimestamp(t);
    if (ts > 0) return ts;
  }

  return 0;
}

function fmtDate(ms) {
  if (!ms) return "—";
  return new Date(ms).toLocaleString("uk-UA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function safeMoney(v) {
  const n = Number(v || 0);
  if (!Number.isFinite(n)) return "—";
  return new Intl.NumberFormat("uk-UA", {
    style: "currency",
    currency: "UAH",
    maximumFractionDigits: 0,
  }).format(n);
}

function shortId(id = "") {
  const s = String(id || "");
  return s.slice(-6) || "—";
}

function getStatus(order = {}) {
  return order?.statusFlow?.current || order?.status || "Очікує підтвердження";
}

function getPaymentMethodRaw(order = {}) {
  const raw =
    order?.payment?.method || order?.paymentMethod || order?.pay || "";
  const v = String(raw).toLowerCase().trim();

  if (v.includes("invoice") || v.includes("рах")) return "invoice";
  if (v.includes("card") || v.includes("карт")) return "card";

  return v || "";
}

function getPaymentMethodLabel(order = {}) {
  const m = getPaymentMethodRaw(order);
  if (m === "invoice") return "По рахунку";
  if (m === "card") return "Картою";
  return m || "—";
}

function getPaymentStatusRaw(order = {}) {
  return (
    order?.payment?.status || order?.paymentStatus || order?.liqpayStatus || ""
  );
}

function isPaidOrder(order = {}) {
  if (order?.isPaid === true) return true;

  const raw = String(getPaymentStatusRaw(order)).toLowerCase().trim();
  return ["paid", "success", "sandbox", "true", "1"].includes(raw);
}

function getPaymentStatusLabel(order = {}) {
  if (isPaidOrder(order)) return "оплачено";

  const raw = String(getPaymentStatusRaw(order)).toLowerCase().trim();

  if (!raw) return "не оплачено";
  if (raw === "pending") return "очікує оплату";
  if (raw === "invoice_pending") return "очікує рахунок";
  if (raw === "invoice_created") return "рахунок сформовано";
  if (raw === "partially_paid") return "частково оплачено";
  if (raw === "failure" || raw === "error") return "помилка";

  return raw;
}

function getInvoiceInfo(order = {}) {
  const invoiceUrl =
    order?.invoiceUrl ||
    order?.invoiceMeta?.invoiceUrl ||
    order?.invoice?.invoiceUrl ||
    "";

  const invoiceNumber =
    order?.invoiceNumber ||
    order?.invoiceMeta?.invoiceNumber ||
    order?.invoice?.invoiceNumber ||
    "";

  const invoiceDate =
    order?.invoiceDate ||
    order?.invoiceMeta?.invoiceDate ||
    order?.invoice?.invoiceDate ||
    "";

  return {
    invoiceUrl: String(invoiceUrl || ""),
    invoiceNumber: String(invoiceNumber || ""),
    invoiceDate: String(invoiceDate || ""),
  };
}

function getOrderTotal(order = {}) {
  const candidates = [
    order?.pricing?.finishPrice,
    order?.finishPrice,
    order?.pricing?.totalPrice,
    order?.totalPrice,
  ];

  for (const v of candidates) {
    const n = Number(v);
    if (Number.isFinite(n)) return n;
  }

  return 0;
}

function getBuyerFullName(order = {}) {
  return (
    order?.buyer?.fullName ||
    order?.userSnapshot?.displayName ||
    [order?.name, order?.surName].filter(Boolean).join(" ") ||
    "—"
  );
}

function getDeliveryLine(order = {}) {
  const city = order?.delivery?.cityName || order?.cityName || "";
  const warehouse =
    order?.delivery?.warehouse || order?.selectedDepartment || "";
  const area = order?.delivery?.cityArea || "";

  const parts = [city, area, warehouse].filter(Boolean);
  return parts.length ? parts.join(", ") : "—";
}

function getItemFinalUnitPrice(el) {
  const qty = Math.max(1, Number(el?.quantity ?? el?.qty ?? 1) || 1);

  const purchasedUnitPrice = Number(el?.purchasedUnitPrice);
  if (Number.isFinite(purchasedUnitPrice) && purchasedUnitPrice > 0) {
    return purchasedUnitPrice;
  }

  const finalPrice = Number(el?.finalPrice);
  if (Number.isFinite(finalPrice) && finalPrice > 0) {
    return finalPrice;
  }

  const unitPrice = Number(el?.unitPrice);
  if (Number.isFinite(unitPrice) && unitPrice > 0) {
    return unitPrice;
  }

  const lineTotal = Number(el?.lineTotal);
  if (Number.isFinite(lineTotal) && lineTotal > 0) {
    return Number((lineTotal / qty).toFixed(2));
  }

  const price = Number(el?.price);
  if (Number.isFinite(price) && price > 0) {
    return price;
  }

  return 0;
}

function isBusinessPartnerOrder(order = {}) {
  const c = String(
    order?.userCategory || order?.userSnapshot?.category || "",
  ).toLowerCase();

  return c.includes("бізнес") && c.includes("партнер");
}

function dayStart(yyyy_mm_dd) {
  return new Date(`${yyyy_mm_dd}T00:00:00`).getTime();
}

function dayEnd(yyyy_mm_dd) {
  return new Date(`${yyyy_mm_dd}T23:59:59.999`).getTime();
}

const PAGE_SIZES = [5, 10, 20, 50];

export default function BusinessPartnerOrders({ user }) {
  const [orders, setOrders] = useState([]);
  const [openMap, setOpenMap] = useState({});
  const [loading, setLoading] = useState(true);

  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [sortDir, setSortDir] = useState("desc");
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);

  const toggleOpen = (id) => {
    setOpenMap((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  useEffect(() => {
    const loadOrders = async () => {
      if (!user?.uid) {
        setOrders([]);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);

        const ordersRef = collection(db, "orders");

        const [snapByUser, snapByUserId] = await Promise.all([
          getDocs(query(ordersRef, where("user", "==", user.uid))),
          getDocs(query(ordersRef, where("userId", "==", user.uid))),
        ]);

        const map = new Map();

        snapByUser.forEach((d) => {
          map.set(d.id, { id: d.id, ...d.data() });
        });

        snapByUserId.forEach((d) => {
          map.set(d.id, { id: d.id, ...d.data() });
        });

        const list = Array.from(map.values())
          .filter((order) => isBusinessPartnerOrder(order))
          .map((order) => ({
            ...order,
            _choice: parseChoice(order?.choice),
          }));

        setOrders(list);
      } catch (e) {
        console.error("Помилка завантаження бізнес-замовлень:", e);
        setOrders([]);
      } finally {
        setLoading(false);
      }
    };

    loadOrders();
  }, [user?.uid]);

  const filteredSortedOrders = useMemo(() => {
    let arr = [...orders];

    if (dateFrom || dateTo) {
      const fromMs = dateFrom ? dayStart(dateFrom) : -Infinity;
      const toMs = dateTo ? dayEnd(dateTo) : Infinity;

      arr = arr.filter((order) => {
        const t = getOrderTs(order);
        return t >= fromMs && t <= toMs;
      });
    }

    arr.sort((a, b) => {
      const A = getOrderTs(a);
      const B = getOrderTs(b);
      return sortDir === "asc" ? A - B : B - A;
    });

    return arr;
  }, [orders, dateFrom, dateTo, sortDir]);

  useEffect(() => {
    setPage(1);
  }, [dateFrom, dateTo, sortDir, pageSize, filteredSortedOrders.length]);

  const totalPages = Math.max(
    1,
    Math.ceil(filteredSortedOrders.length / pageSize),
  );
  const pageClamped = Math.min(page, totalPages);
  const start = (pageClamped - 1) * pageSize;
  const pagedOrders = filteredSortedOrders.slice(start, start + pageSize);

  const hasOrders = filteredSortedOrders.length > 0;

  if (!user?.uid) return null;

  return (
    <div className={css.wrap}>
      <div className={css.head}>
        <h3 className={css.title}>Мої замовлення</h3>
      </div>

      <div className={css.toolbar}>
        <label className={css.control}>
          <span>Період: з</span>
          <input
            type="date"
            value={dateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
            className={css.input}
          />
        </label>

        <label className={css.control}>
          <span>до</span>
          <input
            type="date"
            value={dateTo}
            onChange={(e) => setDateTo(e.target.value)}
            className={css.input}
          />
        </label>

        <label className={css.control}>
          <span>Дата:</span>
          <select
            value={sortDir}
            onChange={(e) => setSortDir(e.target.value)}
            className={css.select}
          >
            <option value="desc">нові зверху</option>
            <option value="asc">старі зверху</option>
          </select>
        </label>

        <label className={css.control}>
          <span>На сторінці:</span>
          <select
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
            className={css.select}
          >
            {PAGE_SIZES.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
        </label>
      </div>

      {loading && <div className={css.empty}>Завантаження...</div>}

      {!loading && !hasOrders && (
        <div className={css.empty}>У вас ще немає бізнес-замовлень.</div>
      )}

      {!loading &&
        pagedOrders.map((order) => {
          const invoice = getInvoiceInfo(order);
          const isOpen = !!openMap[order.id];
          const isPaid = isPaidOrder(order);
          const dueAmount = Number(order?.dueAmount || 0);
          const showPaymentLink =
            !!order?.paymentLink && !isPaid && dueAmount > 0;

          return (
            <div key={order.id} className={css.card}>
              <div className={css.rowTop}>
                <div>
                  <div className={css.label}>Дата</div>
                  <div>{fmtDate(getOrderTs(order))}</div>
                </div>

                <div>
                  <div className={css.label}>ID</div>
                  <div>№{shortId(order.id || order.orderId || order.uid)}</div>
                </div>

                <div>
                  <div className={css.label}>Покупець</div>
                  <div>{getBuyerFullName(order)}</div>
                </div>

                <div>
                  <div className={css.label}>Статус</div>
                  <div>{getStatus(order)}</div>
                </div>

                <div>
                  <div className={css.label}>Оплата</div>
                  <div>{getPaymentMethodLabel(order)}</div>
                </div>

                <div>
                  <div className={css.label}>Оплачено</div>
                  <div>{isPaid ? "Так" : "Ні"}</div>
                </div>

                <div>
                  <div className={css.label}>Сума</div>
                  <div>{safeMoney(getOrderTotal(order))}</div>
                </div>

                <button
                  type="button"
                  className={css.moreBtn}
                  onClick={() => toggleOpen(order.id)}
                >
                  {isOpen ? "Сховати" : "Детальніше"}
                </button>
              </div>

              {isOpen && (
                <div className={css.details}>
                  <div className={css.col}>
                    <h4 className={css.subTitle}>Дані замовлення</h4>

                    <p>
                      <b>Спосіб оплати:</b> {getPaymentMethodLabel(order)}
                    </p>

                    <p>
                      <b>Статус оплати:</b> {getPaymentStatusLabel(order)}
                    </p>

                    <p>
                      <b>Адреса доставки:</b> {getDeliveryLine(order)}
                    </p>

                    <p>
                      <b>Загальна сума:</b> {safeMoney(getOrderTotal(order))}
                    </p>

                    {Number(order?.paidAmount || 0) > 0 && (
                      <p>
                        <b>Оплачено:</b> {safeMoney(order.paidAmount)}
                      </p>
                    )}

                    {Number(order?.dueAmount || 0) > 0 && (
                      <p>
                        <b>До сплати:</b> {safeMoney(order.dueAmount)}
                      </p>
                    )}

                    {invoice?.invoiceUrl && (
                      <p>
                        <b>Рахунок:</b>{" "}
                        <a
                          href={invoice.invoiceUrl}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {invoice.invoiceNumber || "Відкрити рахунок"}
                        </a>
                        {invoice?.invoiceDate
                          ? ` (${invoice.invoiceDate})`
                          : ""}
                      </p>
                    )}

                    {!invoice?.invoiceUrl &&
                      getPaymentMethodRaw(order) === "invoice" && (
                        <p>
                          <b>Рахунок:</b> ще не сформовано
                        </p>
                      )}

                    {showPaymentLink && (
                      <div className={css.payBox}>
                        <b>Посилання для оплати:</b>
                        <a
                          href={order.paymentLink}
                          target="_blank"
                          rel="noreferrer"
                          className={css.payLink}
                        >
                          Відкрити оплату
                        </a>
                      </div>
                    )}
                  </div>

                  <div className={css.col}>
                    <h4 className={css.subTitle}>
                      Позиції ({order._choice.length})
                    </h4>

                    {order._choice.length === 0 && (
                      <div className={css.emptySmall}>Позицій немає</div>
                    )}

                    {order._choice.map((item, index) => {
                      const qty = Number(item?.quantity ?? item?.qty ?? 1) || 1;
                      const price = getItemFinalUnitPrice(item);

                      return (
                        <div key={index} className={css.item}>
                          <div className={css.itemName}>
                            {item?.bookName ||
                              item?.name ||
                              `Товар ${index + 1}`}
                          </div>
                          <div className={css.itemMeta}>x{qty}</div>
                          <div className={css.itemPrice}>
                            {safeMoney(price)}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          );
        })}

      {!loading && hasOrders && (
        <div className={css.paginator}>
          <button
            className={css.pageBtn}
            onClick={() => setPage(1)}
            disabled={pageClamped === 1}
          >
            « Перша
          </button>

          <button
            className={css.pageBtn}
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={pageClamped === 1}
          >
            ‹ Назад
          </button>

          <span className={css.pageInfo}>
            Сторінка {pageClamped} з {totalPages}
          </span>

          <button
            className={css.pageBtn}
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            disabled={pageClamped === totalPages}
          >
            Вперед ›
          </button>

          <button
            className={css.pageBtn}
            onClick={() => setPage(totalPages)}
            disabled={pageClamped === totalPages}
          >
            Остання »
          </button>
        </div>
      )}
    </div>
  );
}
